/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import is from 'is_js'
import Icon from '../common/Icon'
import { floor, decimalPlaces, roundValue, toNonExponential } from '../../utils/number'
import zIndex from '../../utils/zIndexScale'
import { FormatText } from '../../i18n/util'

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: inherit;
`

const InputWrap = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background: ${({ theme }) => theme.inputBgColor};
  line-height: ${({ height }) => height};
  position: relative;
  border-radius: 3px;
  width: inherit;
`

const Input = styled.input`
  height: ${({ height }) => height};
  line-height: ${({ height }) => height};
  box-sizing: border-box;
  outline: none;
  border: 1px solid ${({ theme }) => theme.inputBorder};
  background: inherit;
  border-radius: 3px;
  text-indent: 10px;
  color: ${({ theme }) => theme.inputColor};
  transition: all 0.25s ease;
  z-index: ${zIndex.input};
  position: relative;

  ::placeholder {
    color: ${({ theme }) => theme.inputPlaceholderColor};
  }

  -moz-appearance: none; /* stylelint-disable-line */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    /* stylelint-disable-line */
    -webkit-appearance: none; /* stylelint-disable-line */
  }
  width: ${({ width }) => width};
  padding-right: 35px;
  &:focus {
    border-color: ${({ theme }) => theme.highlight};
  }
`

const Unit = styled.div`
  position: absolute;
  top: 2px;
  right: 5px;
  z-index: ${zIndex.inputUnit};
  color: #828a98;
`

const Increment = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: 5px;
`

const IncrementButton = styled.div`
  width: 24px;
  height: 14px;
  background: ${({ theme }) => theme.inputBgColor};
  border-radius: 3px;
  border: 1px solid ${({ theme }) => theme.exchangeButtonBorderColor};
  color: ${({ theme }) => theme.inputColor};
  line-height: 14px;
  text-align: center;
  cursor: pointer;
  &:hover {
    color: #f0b90b;
  }
`

const Up = styled.div`
  transform: rotate(180deg);
`

const MaxAmount = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  height: 20px;
  line-height: 20px;
  background: ${({ theme }) => theme.exchangeMaxAmountBgColor};
  text-indent: 10px;
  color: ${({ theme }) => theme.exchangeMaxAmountColor};
  font-size: 14px;
  bottom: -18px;
  z-index: ${zIndex.input};
  border-radius: 0px;
`

class FormInput extends React.PureComponent {
  static propTypes = {
    unit: PropTypes.string,
    increment: PropTypes.bool,
    onChange: PropTypes.func,
    width: PropTypes.string,
    type: PropTypes.string,
    step: PropTypes.string,
    min: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.string,
    placeholder: PropTypes.string,
    maxAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }

  static defaultProps = {
    unit: '',
    increment: false,
    onChange: () => {},
    width: '220px',
    type: 'number',
    step: '0.00000001',
    min: '0.00000001',
    value: '',
    height: '30px',
    maxAmount: '',
    placeholder: '',
  }

  constructor(props) {
    super(props)
    this.state = {
      value: props.value,
      original_value: '',
      showMaxAmount: false,
    }
  }

  componentDidUpdate(prevProps) {
    const { value, type } = this.props
    if (type === 'number' && !is.number(parseFloat(value))) return
    if (roundValue(value) !== roundValue(prevProps.value)) {
      this.setState({
        value: parseFloat(value) === 0 ? this.state.value : value,
      })
    }
  }

  _calValue = value => {
    if (!value) return ''
    const { min } = this.props
    let ts = decimalPlaces(min)
    let [, deciam] = String(value).split('.')
    if (deciam === '') return value
    deciam = deciam ? deciam.length : 0
    if (deciam <= ts) {
      ts = deciam
    }
    value = floor(value, ts)
    return value
  }

  _onChange = e => {
    let {
      currentTarget: { value },
    } = e
    const { onChange } = this.props
    const original_value = value
    value = this._calValue(value)
    this.setState(
      {
        value,
        original_value,
      },
      () => {
        onChange && onChange(value)
      }
    )
  }

  _add = () => {
    const { value } = this.state
    const { step, onChange } = this.props
    let newValue
    if (value) {
      newValue = this._calValue(parseFloat(value, 10) + parseFloat(step))
      this.setState(
        {
          value: newValue,
        },
        () => {
          onChange && onChange(newValue)
        }
      )
    } else {
      newValue = this._calValue(parseFloat(step))
      this.setState(
        {
          value: newValue,
        },
        () => {
          onChange && onChange(newValue)
        }
      )
    }
  }

  _minus = () => {
    const { value } = this.state
    const { step, onChange } = this.props
    let newValue
    if (value) {
      newValue = this._calValue(parseFloat(value, 10) - parseFloat(step))
      this.setState(
        {
          value: newValue,
        },
        () => {
          onChange && onChange(newValue)
        }
      )
    } else {
      newValue = this._calValue(parseFloat(step))
      this.setState(
        {
          value: newValue,
        },
        () => {
          onChange && onChange(newValue)
        }
      )
    }
  }

  _onFocus = () => {
    this.setState({ showMaxAmount: true })
  }

  _onBlur = () => {
    this.setState({ showMaxAmount: false })
  }

  render() {
    const { unit, increment, width, type, step, min, maxAmount, height, placeholder } = this.props
    const { value, showMaxAmount, original_value } = this.state
    return (
      <Wrapper>
        <InputWrap height={height} className="inputWrap">
          <Input
            onChange={this._onChange}
            onFocus={this._onFocus}
            onBlur={this._onBlur}
            width={width}
            height={height}
            value={value}
            step={step}
            min={min}
            type={type || 'number'}
            placeholder={placeholder}
            title=""
          />
          {unit && <Unit className="unit">{unit}</Unit>}
          {maxAmount && showMaxAmount && (
            <MaxAmount>
              <FormatText value="exchange.min" />
              {Number(min) < 0.000009 ? toNonExponential(Number(min)) : Number(min)}
            </MaxAmount>
          )}
        </InputWrap>
        {increment && (
          <Increment>
            <IncrementButton onClick={this._add}>
              <Up>
                <Icon type="sanjiaojiantouxia-B" size="10" color="inherit" />
              </Up>
            </IncrementButton>
            <IncrementButton onClick={this._minus}>
              <Icon type="sanjiaojiantouxia-B" size="10" color="inherit" />
            </IncrementButton>
          </Increment>
        )}
      </Wrapper>
    )
  }
}

export default FormInput
